import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IconDoubleArrowLeft } from "@icons";
import "./ProfileSidebarToggle.scss";

interface Props {
    isCollapsed: boolean;
    onToggle: () => void;
    buttonTestId?: string;
}

/** Vertical divider next to `ProfileSidebar` with the collapse/expand button. */
const ProfileSidebarToggle: FCX<Props> = ({ isCollapsed, onToggle, buttonTestId, className, style, testId }) => (
    <div
        className={cn("ProfileSidebarToggle", className, isCollapsed && "is-collapsed")}
        style={style}
        data-testid={testId}
    >
        <button
            type="button"
            className="ProfileSidebarToggle__button"
            onClick={onToggle}
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-expanded={!isCollapsed}
            data-testid={buttonTestId}
        >
            <IconDoubleArrowLeft className="ProfileSidebarToggle__icon"/>
        </button>
    </div>
);

export default ProfileSidebarToggle;
